import { render, staticRenderFns } from "./VerticalLoose.vue?vue&type=template&id=55271333&"
import script from "./VerticalLoose.vue?vue&type=script&lang=js&"
export * from "./VerticalLoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports